import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HalfWidthCol from "./HalfWidthCol";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import LargeHeadingImageSectionAlt from "./LargeHeadingImageSectionAlt";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";

function AboutRepurpose({ image, mobImage, callout, text, sectionId }) {
  return (
    <Box id={sectionId}>
      <LargeHeadingImageSectionAlt
        heading="Reskinned <b><i>Repurpose</i></b>"
        image={image}
        mobImage={mobImage}
        bg="yellow"
      >
        <BoxWithGutter
          mt={[40, null, 100, null]}
          maxWidth={[null, null, null, null]}
          mx="auto"
        >
          <Box pb={[null, null, 60, null]}>
            <IndentedParagraphMedium>{callout}</IndentedParagraphMedium>
          </Box>

          <HalfWidthCol>
            <RichTextLarge>{text}</RichTextLarge>
          </HalfWidthCol>
        </BoxWithGutter>
      </LargeHeadingImageSectionAlt>
    </Box>
  );
}

export default AboutRepurpose;

AboutRepurpose.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  mobImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  callout: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
};
